// src/components/Footer.js
import React from "react";
import "../styles/components/footer.css";

const FooterComponent = () => {
  return (
    <footer className="footerContainer">
      <p>&copy;כל הזכויות שמורות לאדוויס אלקטרוניקה בע"מ</p>
    </footer>
  );
};

export default FooterComponent;
